import { Button, Divider, Modal, TextInput } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAcceptInvitation } from 'src/Hooks/Mutations/useAcceptInvitation';
import { useAcceptInviteCode } from 'src/Hooks/Mutations/useAcceptInviteCode';
import { useFetchMyPendingInvitations } from 'src/Hooks/Queries/useFetchMyPendingInvitations';

import styles from './PendingInvitationsModal.module.scss';
import { Props } from './PendingInvitationsModal.types';

const PendingInvitationsModal = ({ open, onCancel, onAccept }: Props) => {
  const { t } = useTranslation();
  const [inviteCode, setInviteCode] = useState('');

  const { data } = useFetchMyPendingInvitations();
  const { mutate, isLoading } = useAcceptInvitation({
    onSuccess: data => {
      onAccept?.(data);
    },
    onError: onCancel,
  });

  const { mutate: acceptCode, isLoading: isAcceptCodeLoading } = useAcceptInviteCode({
    onSuccess: data => {
      setInviteCode('');
      onAccept?.(data);
    },
  });

  const handleAcceptCode = () => {
    if (inviteCode.trim()) {
      acceptCode(inviteCode.trim());
    }
  };

  return (
    <Modal
      opened={open}
      onClose={onCancel}
      title={
        <div className={styles.title}>
          {t('admin.myInvitations.modal.title', 'Mes invitations en attente')}
        </div>
      }
      withCloseButton={true}
    >
      <div className={styles.container}>
        <div className={styles.invitations}>
          {data?.length === 0 && (
            <div className={styles.noInvite}>
              {t('admin.myInvitations.modal.noInvite', 'Aucune invitation en attente')}
            </div>
          )}
          {data?.map(invitation => (
            <div className={styles.invitation} key={invitation.token}>
              <div className={styles.assetName}> {invitation.asset.name}</div>
              <Button
                size={'compact-sm'}
                onClick={() => mutate(invitation.token)}
                loading={isLoading}
              >
                {t('admin.myInvitations.modal.accept', 'Accepter')}
              </Button>
            </div>
          ))}
        </div>
        <Divider
          my="md"
          label={t('admin.myInvitations.modal.orCode', "Ou entrer un code d'invitation")}
          labelPosition="center"
        />
        <div className={styles.codeSection}>
          <TextInput
            placeholder={t('admin.myInvitations.modal.codePlaceholder', "Code d'invitation")}
            value={inviteCode}
            onChange={e => setInviteCode(e.currentTarget.value.toUpperCase())}
            onKeyDown={e => {
              if (e.key === 'Enter') handleAcceptCode();
            }}
            className={styles.codeInput}
          />
          <Button
            onClick={handleAcceptCode}
            loading={isAcceptCodeLoading}
            disabled={!inviteCode.trim()}
            size="compact-sm"
          >
            {t('admin.myInvitations.modal.joinByCode', 'Rejoindre')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PendingInvitationsModal;
